import React, { useEffect } from 'react';
import {
  TableRow, TableCell, ListItem, ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect } from 'components/FormHelpers/FormInputs';
import moment from 'moment';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { getUIDateFormat, getEmptyValue } from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { compose } from 'recompose';
import { CountrySelector } from 'containers/protocol/components';
import { withChangeHandlers } from 'helpers/Change';
import _ from 'lodash';
import { useSelector } from 'react-redux';

export const ParticipateDate = ({
  startDate,
  participationDate,
  handleDateChange
}) => (
  <MUIDatePicker
    title="Start Date"
    name="participationDate"
    disabled={startDate}
    validators={['required']}
    errorMessages={['Required Field']}
    value={participationDate ? getUIDateFormat(participationDate) : ''}
    onChange={handleDateChange('participationDate')}
  />
);

export const EndDate = ({
  participationEndDate,
  handleDateChange,
  endDate
}) => {
  useEffect(() => {
    
    ValidatorForm.addValidationRule('minDate', value => {
      const dateObj = new Date();
      dateObj.setHours(0, 0, 0, 0);
      if(value){
        return value !== 'Invalid date' && value >= dateObj;
      }
      return true;
    });
  }, [])

  const disabled = endDate ? new Date(moment(endDate, 'DD-MMM-YYYY hh:mm A z')) < new Date() : false;

  return (
    <MUIDatePicker
      title="End Date"
      name="participationEndDate"
      validators={participationEndDate && !disabled ? ['minDate'] : []}
      disabled={disabled}
      errorMessages={participationEndDate && !disabled ? ['End Date cannot be a past date.'] : []}
      value={participationEndDate ? getUIDateFormat(participationEndDate) : ''}
      onChange={handleDateChange('participationEndDate')}
    />
  );
};

export const RegulatoryRqmt = ({ regulatoryRqmt, handleChange }) => (
  <MUISelect
    title="Regulatory Requirement"
    value={getEmptyValue(regulatoryRqmt)}
    name="regulatoryRqmt"
    onChange={handleChange}
  >
    <ListItem button key="regReqTAHolder" value="CTA Holder">
      <ListItemText primary="CTA Holder" />
    </ListItem>
    <ListItem button key="regReqOther" value="Other">
      <ListItemText primary="Other" />
    </ListItem>
    <ListItem button key="regReqNone" value={null}>
      <ListItemText primary="None" />
    </ListItem>
  </MUISelect>
);

export const RegulatoryHolder = ({
  regulatoryHolder, handleChange, participationInfo
}) => {
  const partUniq = _.uniq(_.map(participationInfo, 'participantGroup'));
  return (
    <MUISelect
      title="Regulatory Holder"
      value={getEmptyValue(regulatoryHolder)}
      validators={regulatoryHolder ? ['maxStringLength:100'] : []}
      errorMessages={regulatoryHolder ? ['Maximum 100 characters allowed'] : []}
      onChange={handleChange}
      name="regulatoryHolder"
    >
      {_.map(partUniq, (item, i) => (
        <ListItem
          button
          key={_.uniqueId('parti_country_regulatoryHolder_grp_sel')}
          value={item}
        >
          <ListItemText primary={item} />
        </ListItem>
      ))}
      <ListItem button key="regHolderOther" value="Other">
        <ListItemText primary="Other" />
      </ListItem>
      <ListItem button key="regHolderNone" value={null}>
        <ListItemText primary="None" />
      </ListItem>
    </MUISelect>
  );
};

export const Code = ({
  handleCountryChange, code
}) => (
  <CountrySelector
    name="code"
    onChanged={handleCountryChange}
    validators={['required']}
    errorMessages={['Required Field']}
    selCountry={code}
  />
);

const EditParticipeCountries = (props) => {
  const {
    participationInfo,
    defaultRow,
    state,
    cancel,
    reset,
    handleCountryChange,
    handleDateChange,
    handleChange,
    setState
  } = props || {};

  const dummyRow = {
    participationDate: '',
    participationEndDate: '',
    regulatoryHolder: '',
    regulatoryRqmt: '',
    code: null
  };

  const { prtId } = useSelector(s => s.prtDetails.prtInfo);

  const {
    participationDate,
    participationEndDate,
    regulatoryHolder,
    regulatoryRqmt,
    code 
  } = state || dummyRow;

  useEffect(() => {
    if (state?.prtId == null) {
      setState({
        ...state,
        prtId
      });
    }
  }, [prtId, state, setState]);

  return (
    <TableRow>
      <TableCell className="disableOverflow" colSpan={2}>
        <Code
          code={code}
          handleCountryChange={handleCountryChange}
        />
      </TableCell>
      <TableCell>
        <ParticipateDate
          startDate={defaultRow ? defaultRow.participationDate : null}
          participationDate={participationDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>
        <EndDate
          endDate={defaultRow ? defaultRow.participationEndDate : null}
          participationEndDate={participationEndDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>
        <RegulatoryRqmt
          regulatoryRqmt={regulatoryRqmt}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <RegulatoryHolder
          participationInfo={participationInfo}
          regulatoryHolder={regulatoryHolder}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell align='center'>
        <GridSubmitAction cancel={cancel} reset={reset} />
      </TableCell>
    </TableRow>
  );
};

const EditParticipationCountries = compose(withChangeHandlers)(EditParticipeCountries);

export default EditParticipationCountries;
